import { UnitRelation } from '@bemlo/enums'

import { useTranslations } from '../../translate'
import { BadgeColor } from '../Badge'
import { IconName } from '../Icon'

const UnitRelationMap: Record<
  UnitRelation,
  {
    badgeColor: BadgeColor
    iconName: IconName
  }
> = {
  [UnitRelation.HOME_UNIT]: {
    badgeColor: 'lighter-green',
    iconName: 'HomeIcon',
  },
  [UnitRelation.CROSS_UNIT]: {
    badgeColor: 'transparent-purple',
    iconName: 'OfficeBuildingIcon',
  },
  [UnitRelation.CROSS_ORG]: {
    badgeColor: 'lighter-blue',
    iconName: 'CubeTransparentIcon',
  },
}

export const useUnitRelationBadge = (relation?: UnitRelation) => {
  const t = useTranslations()
  if (relation) {
    const value = UnitRelationMap[relation]
    return {
      ...value,
      text: t.unit_relation(relation),
    }
  }
  return null
}
